<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="save(editForm.value)">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <h2>
          <span>{{ 'plugins.installationstaff.header' | translate }}</span>
        </h2>
      </div>
      <div
        class="ir-content--modal th-content th-content-customer"
        formArrayName="staff"
        *ngFor="let item of formData.controls; let i = index"
      >
        <div>
          <table class="ir-modal-table">
            <tr>
              <td></td>
              <td
                style="width: 50%"
                class="th-plugin-line--remove th-plugin-line--remove-customer"
                colspan="2"
                align="right"
              >
                <i class="material-icons" (click)="openStaffDeleteConfirm(i)">remove_circle</i>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span style="margin-left: 10px">{{ 'plugins.installationstaff.label' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big" [formGroupName]="i">
                <div class="ir-form-group">
                  <input type="text" class="ir-form-set" formControlName="label" />
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span style="margin-left: 10px">{{ 'plugins.installationstaff.staff-type' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big" [formGroupName]="i">
                <div class="ir-form-group">
                  <input type="hidden" class="ir-form-set" formControlName="type" />
                  <div
                    class="ir-line ir-select th-select"
                    (click)="openStaffTypesSelector(item.controls.type.value, i)"
                  >
                    <div class="ir-line--right">
                      <div class="ir-btn th-btn-modal--content">
                        <i class="material-icons">arrow_drop_down</i>
                      </div>
                    </div>
                    <div class="ir-line-content">
                      <span>{{
                        item.controls.type.value && item.controls.type.value >= 0
                          ? (item.controls.type.value | stafftype)
                          : ('plugins.installationstaff.select-staff-type' | translate)
                      }}</span>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span style="margin-left: 10px">{{ 'plugins.installationstaff.quantity' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big" [formGroupName]="i">
                <input
                  name="quantity"
                  class="ir-form-set"
                  type="number"
                  min="0"
                  (keypress)="checkIfPositive($event)"
                  formControlName="quantity"
                />
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span style="margin-left: 10px">{{ 'plugins.installationstaff.provenance' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big" [formGroupName]="i">
                <div class="ir-form-group">
                  <div
                    style="display: inline-block; padding: 0 6em 6em 0"
                    class="margin-big"
                    *ngFor="let prItem of provenanceItems"
                    (click)="changeCheckboxValue(item.controls[prItem.controlKey])"
                  >
                    <i
                      class="material-icons"
                      style="vertical-align: top"
                      *ngIf="!item.controls[prItem.controlKey].value"
                      >check_box_outline_blank</i
                    >
                    <i
                      class="material-icons important"
                      style="vertical-align: top"
                      *ngIf="item.controls[prItem.controlKey].value"
                      >check_box</i
                    >
                    <span>{{ prItem.label | translate }}</span>
                  </div>
                </div>

                <!-- <div class="ir-form-group">
                  <input type="hidden" class="ir-form-set" formControlName="provenance" />
                  <div
                    class="ir-line ir-select th-select"
                    (click)="openProvenanceSelector(item.controls.provenance.value, i)"
                  >
                    <div class="ir-line--right">
                      <div class="ir-btn th-btn-modal--content">
                        <i class="material-icons">arrow_drop_down</i>
                      </div>
                    </div>
                    <div class="ir-line-content">
                      <span>{{
                        item.controls.provenance.value && item.controls.provenance.value >= 0
                          ? (item.controls.provenance.value | provenance)
                          : ('plugins.installationstaff.select-provenance' | translate)
                      }}</span>
                    </div>
                  </div>
                </div> -->
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span style="margin-left: 10px">{{ 'plugins.installationstaff.comment' | translate }}</span>
                </h2>
              </td>
            </tr>
            <tr>
              <td class="margin-big" colspan="2">
                <div class="ir-form-group" [formGroupName]="i">
                  <p class="ir-required th-required visible" [class.visible]="!item.controls.comment.value">
                    <span>{{ 'common.required' | translate }}</span>
                  </p>
                  <textarea
                    id="text"
                    formControlName="comment"
                    rows="3"
                    placeholder="{{ 'plugins.installationstaff.your-comment' | translate }}"
                    class="ir-form-set"
                  ></textarea>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="ir-content--modal th-content th-content-plus">
        <table class="ir-modal-table">
          <tr class="th-plugin-line--add th-plugin-line--add-customer">
            <td colspan="4">
              <i class="material-icons" (click)="add()">add_circle</i>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <modal-footer [editForm]="editForm" [processing]="processing"></modal-footer>
  </form>
</div>
<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<modal (modalOutput)="selectStaffTypesMenu($event)" (modalClosed)="onClose($event)" #staffTypesModal></modal>
<confirm
  #staffDeleteConfirm
  (confirmOutput)="remove($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'Are you sure to delete this <strong>staff</strong>?'"
  [danger]="true"
></confirm>
<confirm
  #pluginDeleteConfirm
  (confirmOutput)="deletePlugin()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
